import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../configuration/colors'

const LoadingContainerDiv = styled.div`
  position: ${props => (props.isFixed ? 'fixed' : 'relative')};
  top: ${props => (props.isFixed ? '0' : 'unset')};
  left: ${props => (props.isFixed ? '0' : 'unset')};
  width: 60px;
  height: ${props => (props.isFullScreen ? '100%' : '')};
  ${props => (props.isFullScreen ? 'min-height: 400px' : '')}
  background: ${props => (props.hasBackground ? 'rgb(36 54 70 / 0.45)' : '')};
  z-index: ${props => (props.hasBackground ? '1000' : 'unset')};

  &.small {
    min-height: 60px;
  }

  @keyframes rotate-loader {
    0% {
      -webkit-transform: rotate(0deg) scale(0.8);
      -moz-transform: rotate(0deg) scale(0.8);
    }
    50% {
      -webkit-transform: rotate(360deg) scale(1.2);
      -moz-transform: rotate(360deg) scale(1.2);
    }
    100% {
      -webkit-transform: rotate(720deg) scale(0.8);
      -moz-transform: rotate(720deg) scale(0.8);
    }
  }

  @keyframes ball1 {
    0% {
      box-shadow: 30px 0 0 ${colors.oeYellow};
    }
    50% {
      box-shadow: 0 0 0 ${colors.amber};
      margin-bottom: 0;
      -webkit-transform: translate(15px, 15px);
      -moz-transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 ${colors.amberLite};
      margin-bottom: 10px;
    }
  }

  @keyframes ball2 {
    0% {
      box-shadow: 30px 0 0 ${colors.oeYellow};
    }
    50% {
      box-shadow: 0 0 0 ${colors.amberLite};
      margin-top: -20px;
      -webkit-transform: translate(15px, 15px);
      -moz-transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 ${colors.oeYellow};
      margin-top: 0;
    }
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -25px 0 0 -25px;
    animation: rotate-loader 1.75s infinite;
    height: 50px;
    width: 50px;

    &:before,
    &:after {
      border-radius: 50%;
      content: '';
      display: block;
      height: 20px;
      width: 20px;
    }

    &:before {
      animation: ball1 1.75s infinite;
      background-color: ${colors.amber};
      box-shadow: 30px 0 0 ${colors.amber};
      margin-bottom: 10px;
    }

    &:after {
      animation: ball2 1.75s infinite;
      background-color: ${colors.oeYellow};
      box-shadow: 30px 0 0 ${colors.oeYellow};
    }
  }
`

const LoadingSpinner = ({ isSmall, isFixed, isFullScreen, hasBackground }) => (
  <LoadingContainerDiv
    isFixed={isFixed}
    isFullScreen={isFullScreen}
    hasBackground={hasBackground}
    className={isSmall ? ' small' : ''}
  >
    <span />
  </LoadingContainerDiv>
)

LoadingSpinner.defaultProps = {
  isSmall: true,
  isFixed: false,
  isFullScreen: false,
  hasBackground: false
}

LoadingSpinner.propTypes = {
  isSmall: PropTypes.bool,
  isFixed: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  hasBackground: PropTypes.bool
}

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/mini/LoadingSpinner.js